import script from "./CoreIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreIndex.vue?vue&type=script&setup=true&lang=js"

import "./CoreIndex.vue?vue&type=style&index=0&id=0d972306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d972306"]])

export default __exports__